// @ts-nocheck
import React from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";
import { URLS } from "./_config";
import requireNoAuth from "./_common/hoc/reqNoAuth";
import requireAuth from "./_common/hoc/reqAuth";
import reqLayout from "./_common/hoc/layout";
import Page404 from "./containers/page-404";
import CacheBuster from "./CacheBuster";
import Register from "./containers/auth/register";
import CompleteProfile from "./containers/auth/complete-profile";
import LoginWithEmailContainer from "./containers/auth/loginWithEmail/login";
import ForgotPassword from "./containers/auth/forgot-password";
import ResetPassword from "./containers/auth/reset-password";
import MyProfile from "./containers/auth/myProfile";
import ViewProfilePage from "./containers/auth/view-profile";
import EditProfilePage from "./containers/auth/edit-profile";
import CmsContainer from "./containers/cms";
import LandingPageContainer from "./containers/landingInfo/landing";
import Dashboard from "./containers/dashboard";
import { NewJobPostingPage, JobPostingThankYouPage } from "./containers/job-posting";
import JobDetailsPage from "./containers/job-details";
import { AICandidateSearchPage } from "./containers/ai-candidate-search";
import { MemberListContainer, AddMemberContainer, EditMemberContainer } from "./containers/members";
// import TalentScoutingContainer from "./containers/talent-scouting/TalentScoutingContainer";
import VerifyEmail from "./containers/auth/verify-email";
import { ComingSoonMain } from "./containers/coming-soon";
import AvalibilityPage from "./containers/interview/avalibility";
import SecurityContainer from "./containers/settings/SecurityContainer";
import SubscriptionsContainer from "./containers/settings/SubscriptionsContainer";
import PaymentSuccessContainer from "./containers/settings/PaymentSuccessContainer";
import PaymentCancelContainer from "./containers/settings/PaymentCancelContainer";
import BillingContainer from "./containers/settings/BillingContainer";
import HistoryContainer from "./containers/settings/HistoryContainer";
import Reports from "./containers/reports/Reports";
import VideoCV from "./containers/video-cv/VideoCV";
import Candidates from "./containers/candidates/Candidates";
import OfferResponsePage from "./containers/offer-response/offer-response";
import InterviewResponseMain from "./components/interview-response/InterviewResponseMain";
import InterviewVideoPage from "./containers/interview-video/interview-video";
import InstantMeetPage from "./containers/instant-meet/instant-meet";
import { ContactUsContainer } from "./containers/contact-us";
import NotificationsContainer from "./containers/notifications/NotificationsContainer";
import JobListingsContainer from "./containers/job-listings/JobListingsContainer";
import AutoLogin from "./containers/autologin/AutoLogin";

function App() {
  return (
    <CacheBuster>
      {({ loading, isLatestVersion, refreshCacheAndReload }) => {
        if (loading) return null;
        if (!loading && !isLatestVersion) {
          refreshCacheAndReload();
        }
        return (
          <React.Fragment>
            <Router>
              <Switch>
                <Route exact path={URLS.AUTH.LOGIN} component={requireNoAuth(LoginWithEmailContainer)} />
                <Route exact path={URLS.AUTH.AUTO_LOGIN_TOKEN} component={AutoLogin} />
                <Route exact path={URLS.AUTH.AUTO_LOGIN()} component={AutoLogin} />
                <Route exact path={URLS.AUTH.REGISTRATION} component={requireNoAuth(Register)} />
                <Route exact path={URLS.AUTH.COMPLETE_PROFILE} component={requireNoAuth(CompleteProfile)} />
                <Route exact path={URLS.AUTH.FORGOT_PASSWORD} component={requireNoAuth(ForgotPassword)} />
                <Route exact path={URLS.AUTH.RESET_PASSWORD} component={requireNoAuth(ResetPassword)} />
                <Route exact path={URLS.AUTH.VERIFY_EMAIL} component={reqLayout(VerifyEmail)} />
                <Route exact path={URLS.AUTH.MY_PROFILE} component={requireAuth(MyProfile)} />
                <Route exact path={URLS.AUTH.VIEW_PROFILE} component={requireAuth(ViewProfilePage)} />
                <Route exact path={URLS.AUTH.EDIT_PROFILE} component={requireAuth(EditProfilePage)} />
                <Route exact path={URLS.DASHBOARD.MAIN} component={requireAuth(Dashboard)} />
                <Route exact path={URLS.JOB_POSTING.EDIT()} component={requireAuth(NewJobPostingPage)} />
                <Route exact path={URLS.JOB_POSTING.NEW} component={requireAuth(NewJobPostingPage)} />
                <Route exact path={URLS.JOB_POSTING.THANK_YOU()} component={requireAuth(JobPostingThankYouPage)} />
                <Route exact path={URLS.JOB_POSTING.JOB_DETAILS} component={requireAuth(JobDetailsPage)} />
                <Route exact path={URLS.JOB_POSTING.OFFER_RESPONSE} component={requireNoAuth(OfferResponsePage)} />
                <Route
                  exact
                  path={URLS.JOB_POSTING.INTERVIEW_RESPONSE}
                  component={requireNoAuth(() => (
                    <InterviewResponseMain />
                  ))}
                />
                <Route exact path={URLS.INTERVIEW.AVALIBILITY} component={requireAuth(AvalibilityPage)} />
                <Route exact path={URLS.INTERVIEW.VIDEO_CALL()} component={reqLayout(InterviewVideoPage)} />
                <Route exact path={URLS.INSTANT_MEET.VIDEO_CALL()} component={reqLayout(InstantMeetPage)} />
                {/* <Route exact path={URLS.JOB_POSTING.TALENT_SCOUTING} component={requireAuth(TalentScoutingContainer)} /> */}
                <Route
                  exact
                  path={URLS.JOB_POSTING.AI_CANDIDATE_SEARCH}
                  component={requireAuth(AICandidateSearchPage)}
                />
                <Route
                  exact
                  path={URLS.JOB_POSTING.AI_CANDIDATE_SEARCH_EDIT()}
                  component={requireAuth(AICandidateSearchPage)}
                />
                <Route exact path={URLS.MEMBERS.LIST} component={requireAuth(MemberListContainer)} />
                <Route exact path={URLS.MEMBERS.ADD} component={requireAuth(AddMemberContainer)} />
                <Route exact path={URLS.MEMBERS.EDIT()} component={requireAuth(EditMemberContainer)} />
                <Route exact path={URLS.SETTINGS.PAYMENT_SUCCESS} component={requireAuth(PaymentSuccessContainer)} />
                <Route exact path={URLS.SETTINGS.PAYMENT_CANCEL} component={requireAuth(PaymentCancelContainer)} />
                <Route exact path={URLS.SETTINGS.SECURITY} component={requireAuth(SecurityContainer)} />
                <Route exact path={URLS.SETTINGS.SUBSCRIPTIONS} component={requireAuth(SubscriptionsContainer)} />
                <Route exact path={URLS.SETTINGS.BILLING} component={requireAuth(BillingContainer)} />
                <Route exact path={URLS.SETTINGS.HISTORY} component={requireAuth(HistoryContainer)} />
                <Route exact path={URLS.REPORTS.MAIN} component={requireAuth(Reports)} />
                <Route exact path={URLS.VIDEO_CV.MAIN} component={requireAuth(VideoCV)} />
                <Route exact path={URLS.CANDIDATES.MAIN} component={requireAuth(Candidates)} />
                <Route exact path={URLS.JOB_POSTING.JOB_LISTINGS} component={requireAuth(JobListingsContainer)} />
                <Route exact path={URLS.NOTIFICATIONS.MAIN} component={requireAuth(NotificationsContainer)} />
                <Route exact path={URLS.SUPPORT.CONTACT_US} component={requireAuth(ContactUsContainer)} />
                <Route path="/coming-soon" component={requireAuth(ComingSoonMain)} />

                {/* <Route exact path={URLS.JOB_POSTING.AI_DESCRIPTION} component={requireAuth(AIJobDescriptionPage)} /> */}
                <Route exact path={URLS.CMS.CMS} component={reqLayout(CmsContainer)} />
                <Route path="*" component={reqLayout(Page404)} />
              </Switch>
            </Router>
          </React.Fragment>
        );
      }}
    </CacheBuster>
  );
}

export default App;
